import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Col, Container, Row } from "react-bootstrap";
import { useGetFetchNew } from "../../../data/Queries";
import { selectUser } from "../../auth/auth.selector";
import CommonStructured from "../../common-components/CommonStructured";
import Modal from "react-modal";
import ManageSchedule from "./ManageSchedule";
import { formatDate } from "../../../utils/utilityfunc";
import { commonDeleteApi } from "../../../redux/reducers/deleteApiSlice";
import {
  academy_course_schedule,
  delete_academy_course_schedule,
} from "../../../data/ApiEndpoints";
import { toast } from "react-toastify";
import { showConfirmAlert } from "../../components-react/ReactAlert";
import { DeleteIcon, EditIcon } from "../../../images/icons/website-icons";
import PaymentLinkTable from "../../payment-link-system/PaymentLinkTable";

import { convertTo12HourFormat } from "../../common-data/Converts";

const AcademyCourseSchedule = () => {
  const dispatch = useDispatch();
  const userInfoData = useSelector(selectUser);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedSchedule, setSelectedSchedule] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [page, setPage] = useState(0);
  const [pageLimit, setPageLimit] = useState(8);

  const {
    data,
    isLoading: dataLoading,
    refetch,
  } = useGetFetchNew({
    token: userInfoData?.token,
    key: "academy_course_schedule",
    url: academy_course_schedule,
    filters: {
      limit: pageLimit,
      page: page + 1,
    },
  });

  const handleModalClose = () => {
    setIsModalOpen(false);
    setSelectedSchedule(null);
  };

  const handleAddSchedule = () => {
    setIsModalOpen(true);
    setSelectedSchedule(null);
  };

  const handleEditSchedule = (schedule) => {
    setSelectedSchedule(schedule);
    setIsModalOpen(true);
  };

  const handleDeleteSchedule = async (schedule) => {
    if (schedule?.uid) {
      const handleConfirm = async () => {
        try {
          const response = await dispatch(
            commonDeleteApi({
              TOKEN: userInfoData?.token,
              endpoint: delete_academy_course_schedule,
              queryParams: { uid: schedule.uid },
            })
          ).unwrap();

          if (response?.status) {
            toast.success(
              response?.message || "Schedule deleted successfully!"
            );
            refetch();
          } else {
            toast.error(response?.message || "Cannot delete schedule!");
          }
        } catch (error) {
          toast.error(error?.message || "Failed to delete schedule");
        }
      };

      showConfirmAlert(
        handleConfirm,
        "Are you sure you want to delete this schedule?"
      );
    } else {
      toast.error("Schedule ID required!");
    }
  };

  const tbColumns = [
    {
      dataField: "course_title",
      text: "Course Title",
      formatter: (cell, row) => (
        <span className="tb-data">{row.course_title || "NA"}</span>
      ),
    },
    {
      dataField: "start_date",
      text: "Start Date",
      formatter: (cell, row) => (
        <span className="tb-data">{formatDate(row.start_date)}</span>
      ),
    },
    {
      dataField: "end_date",
      text: "End Date",
      formatter: (cell, row) => (
        <span className="tb-data">{formatDate(row.end_date)}</span>
      ),
    },
    {
      dataField: "batch_type",
      text: "Batch Type",
      formatter: (cell, row) => (
        <span className="tb-data" style={{ textTransform: "capitalize" }}>
          {row.batch_type}
        </span>
      ),
    },
    {
      dataField: "timing",
      text: "Timing",
      formatter: (cell, row) => (
        <span className="tb-data">
          {`${convertTo12HourFormat(
            row.batch_start_time
          )} - ${convertTo12HourFormat(row.batch_end_time)}`}
        </span>
      ),
    },
    {
      dataField: "location",
      text: "Location",
      formatter: (cell, row) => (
        <span className="tb-data" style={{ textTransform: "capitalize" }}>
          {row.location}
        </span>
      ),
    },
    {
      dataField: "instructor_name",
      text: "Instructor",
      formatter: (cell, row) => (
        <span className="tb-data">{row.instructor_name || "NA"}</span>
      ),
    },
    {
      dataField: "status",
      text: "Status",
      formatter: (cell, row) => {
        return (
          <span className="tb-data flexCenter">
            <span
              className={
                row?.status === "active" ? "greenColorBg" : "redColorBg"
              }
            >
              {row?.status || "NA"}
            </span>
          </span>
        );
      },
    },
    {
      dataField: "actions",
      text: "Actions",
      formatter: (cell, row) => {
        return (
          <div className="actionButtonContainer">
            <button
              className="actionBtn icon edit"
              onClick={() => handleEditSchedule(row)}
              disabled={isLoading}
            >
              <EditIcon />
            </button>
            <button
              className="actionBtn icon delete"
              onClick={() => handleDeleteSchedule(row)}
              disabled={isLoading}
            >
              <DeleteIcon />
            </button>
          </div>
        );
      },
    },
  ];

  return (
    <Container className="bg-cloud-k px-50px gobal-container" fluid>
      <Row>
        <Col>
          <CommonStructured
            pageHeading={"Academy Course Schedule"}
            createBtnTxt={"+ Add Course Schedule"}
            onClickCreateBtn={handleAddSchedule}
          />
        </Col>
      </Row>

      {/* <FilterContainer>
        <SearchFilter />
      </FilterContainer> */}

      <div className="fullWidthFlexCenter overflowAuto separatedTable no-border-table mt30">
        <PaymentLinkTable
          tableData={data?.data}
          tableColumns={tbColumns}
          userInfoData={userInfoData}
          isPage={page}
          setIsPage={(value) => setPage(value)}
          isLoading={dataLoading}
          tablePagination={data?.pagination}
          setPageLimit={setPageLimit}
          pageLimit={pageLimit}
        />
      </div>

      <Modal
        isOpen={isModalOpen}
        onRequestClose={handleModalClose}
        ariaHideApp={false}
        contentLabel="Schedule Modal"
        // className="modal-dialog modal-lg"
        // overlayClassName="modal-overlay"
      >
        <ManageSchedule
          closeModal={handleModalClose}
          token={userInfoData?.token}
          initialValues={selectedSchedule}
          refetchScheduleList={refetch}
        />
      </Modal>
    </Container>
  );
};

export default AcademyCourseSchedule;
